<template>
  <el-dialog :title="$t('message.adjustPorderSealer')" :visible.sync="visible" width="460px" center
    :close-on-click-modal="false" :close-on-press-escape="!saving" :show-close="!saving">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" class="sealer-form">
      <el-form-item :label="$t('message.defaultSealer') + '：'" prop="sealer_id">
        <el-select v-model="form.sealer_id" filterable clearable :disabled="loading || saving" :loading="loading"
          :placeholder="$t('message.selectDefaultSealer')">
          <el-option v-for="item in candidates" :key="item.id" :label="item.realname" :value="item.id" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="saving" :disabled="!canAssign || loading" @click="save">
        {{ $t('message.immediateAdjustment') }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    candidates: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    canAssign: { type: Boolean, default: false },
  },
  data() {
    return {
      visible: false,
      saving: false,
      porderSns: [],
      form: { sealer_id: '' },
      rules: {
        sealer_id: [{
          validator: (rule, value, callback) => {
            if (!Number.isInteger(value) || value <= 0 || !this.candidates.some(item => item.id === value)) {
              return callback(new Error(this.$t('message.selectDefaultSealer')))
            }
            callback()
          },
          trigger: 'change',
        }],
      },
    }
  },
  methods: {
    // 候选项与列表筛选共用父页面的数据，每次调整均不预选人员。
    open(porderSns) {
      if (!this.canAssign || this.saving) return
      this.porderSns = [...porderSns]
      this.form.sealer_id = ''
      this.visible = true
      this.$nextTick(() => this.$refs.form.clearValidate())
    },
    save() {
      if (!this.canAssign || this.loading || this.saving) return
      this.saving = true
      this.$refs.form.validate(async (valid) => {
        if (!valid || !this.canAssign) {
          this.saving = false
          return
        }
        try {
          // 此接口支持批量单号，选中多个配送单也只提交一次。
          const res = await this.$api.porderApi.sealingAssign({
            porder_sn: this.porderSns,
            sealer_id: this.form.sealer_id,
          })
          if (res.code != 0 || res.success === false) return
          this.$message.success(res.msg)
          this.visible = false
          this.$emit('saved')
        } catch (error) {
          // 失败提示由公共请求层处理，避免重复弹出。
        } finally {
          this.saving = false
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.sealer-form {
  padding: 10px 20px 0;

  .el-select {
    width: 100%;
  }
}
</style>
